/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Name_Notification_AgentInputs */

const tr_agents_name_notification_agent = /** @type {(inputs: Agents_Name_Notification_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirim Asistanı`)
};

const en_agents_name_notification_agent = /** @type {(inputs: Agents_Name_Notification_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Agent`)
};

const de_agents_name_notification_agent = /** @type {(inputs: Agents_Name_Notification_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungs-Assistent`)
};

const ru_agents_name_notification_agent = /** @type {(inputs: Agents_Name_Notification_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помощник по уведомлениям`)
};

/**
* | output |
* | --- |
* | "Notification Agent" |
*
* @param {Agents_Name_Notification_AgentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const agents_name_notification_agent = /** @type {((inputs?: Agents_Name_Notification_AgentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Name_Notification_AgentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agents_name_notification_agent(inputs)
	if (locale === "de") return de_agents_name_notification_agent(inputs)
	if (locale === "ru") return ru_agents_name_notification_agent(inputs)
	return tr_agents_name_notification_agent(inputs)
});